export const LANGS = [
  { code: "hing", label: "Hinglish", short: "Hing" },
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिंदी", short: "हिं" },
];

export const T = {
  hing: {
    navProducts: "Products", navAbout: "About", navStories: "Stories", navCrops: "Crop Guide", navUpdates: "Updates", navContact: "Contact",
    navFittings: "Fittings", menuFittings: "Fittings & Accessories",
    enquire: "Enquire", becomeDealer: "Become a Dealer",
    heroExplore: "Explore the Range", heroEnquire: "Enquire Now", scroll: "Scroll",
    productsOverline: "The Range — Poora Saman",
    productsHeadA: "Built for the field.", productsHeadMid: "Engineered to", productsHeadAccent: "last.",
    productsIntro: "Har item ki poori listing — photo, description, features aur poori range ke saath. ISI-grade material, pressure-tested quality.",
    rangeIncludes: "Range Includes", enquireFor: "Enquire for",
    statsOverline: "Why Jamna — Bharosa Ka Saboot",
    storiesOverline: "Success Stories — Kisanon Ki Zubani",
    storiesHeadA: "Kisan khud", storiesHeadAccent: "bol rahe hain.",
    cropsOverline: "Crop Guide — Fasal Anusaar Sahi System",
    cropsHeadA: "Har fasal ke liye", cropsHeadAccent: "sahi sinchai.",
    cropsIntro: "Apni fasal chunein aur dekhein kaunsa Jamna system sabse sahi rahega — aur kitna paani bachega.",
    recommended: "Recommended:", savingUpTo: "Paani ki bachat up to",
    updatesOverline: "Updates — Taza Khabar",
    updatesHeadA: "Jamna se", updatesHeadAccent: "latest.",
    appHeadA: "Hamara app", appHeadAccent: "download karein.",
    downloadApk: "Download APK", comingSoon: "App Coming Soon",
    teamOverline: "Our Team — Hamari Team",
    teamHeadA: "Jamna ki asli", teamHeadAccent: "taakat.", totalSales: "Total Sales",
    contactOverline: "Contact — Sampark Karein",
    contactHeadA: "Kheti ka saathi,", contactHeadMid: "sirf ek", contactHeadAccent: "enquiry", contactHeadPost: "door.",
    contactPara: "Apni requirement bhejein — hamari team 24 ghante ke andar dealer pricing aur site survey ke saath aapse sampark karegi.",
    callWhatsapp: "Call / WhatsApp", emailLabel: "Email", works: "Works",
    enquiryForm: "Enquiry Form", reply24: "24 ghante mein jawab — guaranteed",
    labelName: "Naam / Name *", labelPhone: "Phone Number *", labelProduct: "Product Interest", labelRequirement: "Aapki Requirement *",
    reqPlaceholder: "e.g. 5 acre kapas ke liye mini sprinkler system chahiye...",
    sendEnquiry: "Send Enquiry", sending: "Bhej rahe hain...",
    toastSuccess: "Enquiry received! Jamna team aapse jald sampark karegi.",
    toastError: "Kuch gadbad ho gayi. Please call us directly.",
    footerCtaA: "Let's Grow", footerCtaAccent: "Together.", startEnquiry: "Start an Enquiry",
    brandBlurb: "HDPE pipes, mini sprinkler systems, drip irrigation aur fittings — made in India, made for the Indian farmer.",
    colProducts: "Products", colCompany: "Company", colContact: "Contact",
    footerLegacy: "Our Legacy", footerTeam: "Our Team", footerStories: "Success Stories", footerCrops: "Crop Guide", footerUpdates: "Updates", footerDealer: "Become a Dealer",
    madeIn: "Made in India — Har Boond Mein Vikas",
    menuHome: "Home", menuAbout: "About / Legacy", menuTeam: "Team",
    menuProducts: "Products", contactUs: "Sampark Karein",
    taglineLine: "Har Boond Mein Vikas.",
    allProducts: "All Products", itemsList: "Items / Fittings List",
    navWhoWeAre: "Who We Are", navSegments: "Segments",
    menuHistory: "Our History", menuLeadership: "Leadership", menuSustainability: "Sustainability", menuSegments: "Segments",
    completeRange: "Complete Range", followUs: "Follow Us", downloadCatalogue: "Download Catalogue", moreModels: "aur models", menuCropAdvisor: "AI Crop Advisor",
  },
  en: {
    navProducts: "Products", navAbout: "About", navStories: "Stories", navCrops: "Crop Guide", navUpdates: "Updates", navContact: "Contact",
    navFittings: "Fittings", menuFittings: "Fittings & Accessories",
    enquire: "Enquire", becomeDealer: "Become a Dealer",
    heroExplore: "Explore the Range", heroEnquire: "Enquire Now", scroll: "Scroll",
    productsOverline: "The Range — Full Catalogue",
    productsHeadA: "Built for the field.", productsHeadMid: "Engineered to", productsHeadAccent: "last.",
    productsIntro: "Complete listing for every product — with photo, description, features and the full range. ISI-grade material, pressure-tested quality.",
    rangeIncludes: "Range Includes", enquireFor: "Enquire for",
    statsOverline: "Why Jamna — Proof of Trust",
    storiesOverline: "Success Stories — In Farmers' Words",
    storiesHeadA: "Farmers are", storiesHeadAccent: "speaking.",
    cropsOverline: "Crop Guide — Right System for Every Crop",
    cropsHeadA: "The right irrigation", cropsHeadAccent: "for every crop.",
    cropsIntro: "Choose your crop and see which Jamna system fits best — and how much water it saves.",
    recommended: "Recommended:", savingUpTo: "Water saving up to",
    updatesOverline: "Updates — Latest News",
    updatesHeadA: "Latest from", updatesHeadAccent: "Jamna.",
    appHeadA: "Download", appHeadAccent: "our app.",
    downloadApk: "Download APK", comingSoon: "App Coming Soon",
    teamOverline: "Our Team",
    teamHeadA: "Jamna's real", teamHeadAccent: "strength.", totalSales: "Total Sales",
    contactOverline: "Contact — Get in Touch",
    contactHeadA: "Your farming partner,", contactHeadMid: "just one", contactHeadAccent: "enquiry", contactHeadPost: "away.",
    contactPara: "Send your requirement — our team will contact you within 24 hours with dealer pricing and site survey.",
    callWhatsapp: "Call / WhatsApp", emailLabel: "Email", works: "Works",
    enquiryForm: "Enquiry Form", reply24: "Reply within 24 hours — guaranteed",
    labelName: "Name *", labelPhone: "Phone Number *", labelProduct: "Product Interest", labelRequirement: "Your Requirement *",
    reqPlaceholder: "e.g. Need a mini sprinkler system for 5 acres of cotton...",
    sendEnquiry: "Send Enquiry", sending: "Sending…",
    toastSuccess: "Enquiry received! The Jamna team will contact you soon.",
    toastError: "Something went wrong. Please call us directly.",
    footerCtaA: "Let's Grow", footerCtaAccent: "Together.", startEnquiry: "Start an Enquiry",
    brandBlurb: "HDPE pipes, mini sprinkler systems, drip irrigation and fittings — made in India, made for the Indian farmer.",
    colProducts: "Products", colCompany: "Company", colContact: "Contact",
    footerLegacy: "Our Legacy", footerTeam: "Our Team", footerStories: "Success Stories", footerCrops: "Crop Guide", footerUpdates: "Updates", footerDealer: "Become a Dealer",
    madeIn: "Made in India — Progress in Every Drop",
    menuHome: "Home", menuAbout: "About / Legacy", menuTeam: "Team",
    menuProducts: "Products", contactUs: "Get in Touch",
    taglineLine: "Progress in Every Drop.",
    allProducts: "All Products", itemsList: "Items / Fittings List",
    navWhoWeAre: "Who We Are", navSegments: "Segments",
    menuHistory: "Our History", menuLeadership: "Leadership", menuSustainability: "Sustainability", menuSegments: "Segments",
    completeRange: "Complete Range", followUs: "Follow Us", downloadCatalogue: "Download Catalogue", moreModels: "more models", menuCropAdvisor: "AI Crop Advisor",
  },
  hi: {
    navProducts: "प्रोडक्ट्स", navAbout: "हमारे बारे में", navStories: "किसान कहानियां", navCrops: "फसल गाइड", navUpdates: "अपडेट्स", navContact: "संपर्क",
    navFittings: "फिटिंग", menuFittings: "फिटिंग और एक्सेसरीज",
    enquire: "पूछताछ करें", becomeDealer: "डीलर बनें",
    heroExplore: "पूरी रेंज देखें", heroEnquire: "पूछताछ करें", scroll: "स्क्रॉल",
    productsOverline: "पूरी रेंज — सभी प्रोडक्ट्स",
    productsHeadA: "खेत के लिए बने।", productsHeadMid: "हमेशा", productsHeadAccent: "टिकाऊ।",
    productsIntro: "हर प्रोडक्ट की पूरी जानकारी — फोटो, विवरण, फीचर्स और पूरी रेंज के साथ। ISI-ग्रेड मटेरियल, प्रेशर-टेस्टेड क्वालिटी।",
    rangeIncludes: "रेंज में शामिल", enquireFor: "की पूछताछ करें",
    statsOverline: "जम्ना क्यों — भरोसे का सबूत",
    storiesOverline: "सफलता की कहानियां — किसानों की जुबानी",
    storiesHeadA: "किसान खुद", storiesHeadAccent: "बोल रहे हैं।",
    cropsOverline: "फसल गाइड — हर फसल के लिए सही सिस्टम",
    cropsHeadA: "हर फसल के लिए", cropsHeadAccent: "सही सिंचाई।",
    cropsIntro: "अपनी फसल चुनें और देखें कौन सा जम्ना सिस्टम सबसे सही रहेगा — और कितना पानी बचेगा।",
    recommended: "सुझाया गया:", savingUpTo: "पानी की बचत",
    updatesOverline: "अपडेट्स — ताजा खबर",
    updatesHeadA: "जम्ना से", updatesHeadAccent: "ताजा खबर।",
    appHeadA: "हमारा ऐप", appHeadAccent: "डाउनलोड करें।",
    downloadApk: "APK डाउनलोड करें", comingSoon: "ऐप जल्द आ रहा है",
    teamOverline: "हमारी टीम",
    teamHeadA: "जम्ना की असली", teamHeadAccent: "ताकत।", totalSales: "कुल बिक्री",
    contactOverline: "संपर्क करें",
    contactHeadA: "खेती का साथी,", contactHeadMid: "बस एक", contactHeadAccent: "पूछताछ", contactHeadPost: "दूर।",
    contactPara: "अपनी जरूरत भेजें — हमारी टीम 24 घंटे के अंदर डीलर प्राइस और साइट सर्वे के साथ आपसे संपर्क करेगी।",
    callWhatsapp: "कॉल / व्हाट्सऐप", emailLabel: "ईमेल", works: "कार्यालय / फैक्ट्री",
    enquiryForm: "पूछताछ फॉर्म", reply24: "24 घंटे में जवाब — गारंटीड",
    labelName: "नाम *", labelPhone: "फोन नंबर *", labelProduct: "प्रोडक्ट में रुचि", labelRequirement: "आपकी जरूरत *",
    reqPlaceholder: "जैसे: 5 एकड़ कपास के लिए मिनी स्प्रिंकलर सिस्टम चाहिए...",
    sendEnquiry: "पूछताछ भेजें", sending: "भेजा जा रहा है…",
    toastSuccess: "पूछताछ मिल गई! जम्ना टीम आपसे जल्द संपर्क करेगी।",
    toastError: "कुछ गड़बड़ हो गई। कृपया सीधे कॉल करें।",
    footerCtaA: "आइए साथ", footerCtaAccent: "बढ़ें।", startEnquiry: "पूछताछ शुरू करें",
    brandBlurb: "HDPE पाइप, मिनी स्प्रिंकलर सिस्टम, ड्रिप सिंचाई और फिटिंग — भारत में निर्मित, भारतीय किसान के लिए।",
    colProducts: "प्रोडक्ट्स", colCompany: "कंपनी", colContact: "संपर्क",
    footerLegacy: "हमारी विरासत", footerTeam: "हमारी टीम", footerStories: "किसान कहानियां", footerCrops: "फसल गाइड", footerUpdates: "अपडेट्स", footerDealer: "डीलर बनें",
    madeIn: "मेड इन इंडिया — हर बूंद में विकास",
    menuHome: "होम", menuAbout: "हमारे बारे में", menuTeam: "टीम",
    menuProducts: "प्रोडक्ट्स", contactUs: "संपर्क करें",
    taglineLine: "हर बूंद में विकास।",
    allProducts: "सभी प्रोडक्ट्स", itemsList: "आइटम्स / फिटिंग सूची",
    navWhoWeAre: "हम कौन हैं", navSegments: "सेगमेंट्स",
    menuHistory: "हमारा इतिहास", menuLeadership: "नेतृत्व", menuSustainability: "स्थिरता", menuSegments: "सेगमेंट्स",
    completeRange: "पूरी रेंज", followUs: "फॉलो करें", downloadCatalogue: "कैटलॉग डाउनलोड करें", moreModels: "और मॉडल", menuCropAdvisor: "AI क्रॉप एडवाइज़र",
  },
};
